import { ReactNode, useMemo, useState } from "react";
import { Card } from "react-bootstrap";
import useGetTableData from "../../hook/useGetTableData";
import TableTemplate from "../component/table-pagination";
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from "../utils/Constant";
import PatientInfoModal from "./components/patient-info-modal";
import PatientFilter from "./components/PatientFilter";
import { PATIENT_COLUMNS } from "./constants/columns";
import { getPatients } from "./services/PatientServices";

type ColumnActionType = "viewPatient" | "viewMedicalRecord";

const Patients = () => {
	const { query, setQuery, data, paging } = useGetTableData({
		fetchApi: getPatients,
		initialQuery: {
			pageIndex: DEFAULT_PAGE_INDEX,
			pageSize: DEFAULT_PAGE_SIZE,
		},
	});
	const [dynamicComponent, setDynamicComponent] = useState<{
		key: string;
		data: any;
	}>({
		key: "",
		data: null,
	});

	const tableData = useMemo(() => {
		return data?.content
			? data?.content.map((item: any, index: number) => {
					return {
						...item,
						order: (query?.pageIndex > 1 ? query.pageIndex - 1 : 0) * query?.pageSize + index + 1,
					};
			  })
			: [];
	}, [data]);

	const onModalClose = () => {
		setDynamicComponent({
			key: "",
			data: null,
		});
	};

	const onActionButtonClick = (rowData: any, actionType: ColumnActionType) => {
		setDynamicComponent({
			key: actionType,
			data: rowData,
		});
	};

	const DynamicComponent = useMemo(() => {
		const componentMap: Record<ColumnActionType, ReactNode> = {
			viewPatient: (
				<PatientInfoModal open onClose={onModalClose} patientInfo={dynamicComponent.data} />
			),
			viewMedicalRecord: "",
		};
		return componentMap[dynamicComponent.key as keyof typeof componentMap];
	}, [dynamicComponent.key]);

	return (
		<Card className="p-3">
			<PatientFilter
				onSearch={(params) => {
					setQuery({
						...query,
						...params,
						pageIndex: DEFAULT_PAGE_INDEX,
					});
				}}
			/>
			<TableTemplate
				data={tableData}
				columns={PATIENT_COLUMNS}
				paging={{
					...paging,
					page: query?.pageIndex,
					rowsPerPage: query?.pageSize,
				}}
				selectable={false}
				tableClassname="h-calc-vh-200"
				onPagingChange={(page, size) => {
					setQuery({
						...query,
						pageIndex: page,
						pageSize: size,
					});
				}}
				tableOptions={{
					onActionButtonClick,
				}}
			/>
			{dynamicComponent.key && DynamicComponent}
		</Card>
	);
};

export default Patients;
